//@flow
import * as React from 'react'
import { useState } from 'react'
import classnames from 'classnames'

import { useRangeStyles } from './styles'

type RangeProps = {
  id?: string,
  min?: number,
  max?: number,
  label?: string,
  isReversed?: boolean,
  value?: number,
  defaultValue?: number,
  onChange?: (value: number) => void,
  wrapperProps?: { [key: string]: any }
}

const Range = ({
  id,
  value,
  defaultValue,
  label,
  min,
  max,
  isReversed,
  wrapperProps,
  onChange = () => {},
  ...props
}: RangeProps) => {
  const classes = useRangeStyles()
  const [internalValue, setInternalValue] = useState(value || 0)

  const handleInternalChange = (event: SyntheticEvent<HTMLInputElement>) => {
    const newValue = Number(event.currentTarget.value)

    if ((min && newValue < min) || (max && newValue > max)) {
      return false
    }

    setInternalValue(Number(event.currentTarget.value))
  }

  const handleChange = () => onChange(internalValue)

  return (
    <div className={classes.rangeWrapper} {...wrapperProps}>
      {label && <label id={`${id || 'range'}-label`}>{label}</label>}
      <div className={classes.rangeInputWrapper} {...wrapperProps}>
        <input
          className={classnames(classes.rangeInput, {
            isReversed
          })}
          defaultValue={defaultValue}
          id={id}
          max={max}
          min={min}
          type="range"
          value={internalValue}
          onChange={handleInternalChange}
          onMouseUp={handleChange}
          {...props}
        />
        <input
          className={classes.rangeInputNumber}
          defaultValue={defaultValue}
          id={id ? `${id}-number` : ''}
          max={max}
          min={min}
          type="number"
          value={internalValue}
          onBlur={handleChange}
          onChange={handleInternalChange}
        />
      </div>
    </div>
  )
}

export default Range
